import React from "react";

import { APP_COLOR, APP_FONT_SIZE } from '../atoms/AtomsGlobalProps'
import Paragraph from '../atoms/Paragraph/Paragraph'


import "./footer-styles.scss"


const Footer = () => {
   return (
      <footer className='page-footer-outer-wrapper' >
        <Paragraph size={ APP_FONT_SIZE.EXTRA_SMALL } color={ APP_COLOR.GRAY } >
            &#169; { new Date().getFullYear() } Paytree SA właściciel marki Opena
        </Paragraph>
      </footer>
   )
}

export default Footer